<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center">
      <b-col cols="12" md="4" >
        <font-awesome-icon :icon="['fas', 'times-circle']" class="text-danger my-auto success-icon"></font-awesome-icon>
        <h3 class="font-weight-bolder mt-3">Payment Failed!</h3>
        <p class="" style="margin-bottom: 55px">{{errorMessage}}</p>
        <button class="btn btn-primary btn-block" @click="goToHome">Continue</button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "TransactionFailedPage",
  data() {
    return {
      errorMessage:'',
    }
  },
  mounted() {
    if(this.paymentError!==''){
      this.errorMessage = this.paymentError.msg;
    }
    this.removePaymentData();
    this.removePaymentDataSubscription();
    this.removePaymentDataDonation();
    this.removePaymentError();
  },
  computed:{
    ...mapGetters('PaymentModule', ['paymentError']),
  },
  methods:{
    ...mapActions('PaymentModule', ['removePaymentDataSubscription','removePaymentData','removePaymentDataDonation','removePaymentError']),
    goToHome(){
      this.$router.push({ name: 'HomePage' });
    },
  },
}
</script>

<style scoped>
.cursor-pointer{
  cursor: pointer;
}
.success-icon{
  font-size: 134px
}
.credit-text{
  font-size: 100px;
}
.copy-icon-link{
  right: -40px;top: 25px;
}
.copy-icon{
  width: 40px; height: 50px; margin:auto
}
.social-item img{
  width: 45px;
}
@media screen and (max-width: 767.98px) {
  .credit-text{
    font-size: 50px;
  }
  .copy-icon-link{
    right: 0;
    top: 12px;
  }
  .copy-icon{
    width: 20px; height: 30px; margin:auto
  }
}
</style>



// WEBPACK FOOTER //
// src/views/TransactionFailed.vue